<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData"></mainHead> -->
		<div class="headTabs">
			<el-tabs v-model="activeTab" @tab-click="tabChange">
				<el-tab-pane label="应用基本信息" value="1" name="1"></el-tab-pane>
				<el-tab-pane label="应用资质信息" value="2" name="2" :disabled="!mediaFormData.id"></el-tab-pane>
				<el-tab-pane label="媒体应用设置" value="3" name="3" :disabled="!mediaFormData.id"></el-tab-pane>
			</el-tabs>
		</div>
		<el-form inline class="el-form el_dialog_forms" label-width="180px" :rules="rulesApi" :model="mediaFormData"
			ref="ruleCompanyForm" v-show="activeTab == 1">
			<div class="mianPage">
				<!-- {{adEditTitle}} -->
				<div class="titleRow">{{activeTabName}}</div>
				<div class="splitLine"></div>
				<el-form-item label="公司名称：" prop="companyId">
					<el-select v-model="mediaFormData.companyId" filterable clearable size="small" placeholder="请选择公司名称"
					:disabled="isFormDisable">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用属性：" prop="appProperty">
					<el-radio v-model="mediaFormData.appProperty" :label="2" :disabled="isFormDisable">正式</el-radio>
					<el-radio v-model="mediaFormData.appProperty" :label="1" :disabled="isFormDisable">测试</el-radio>
				</el-form-item>
				<el-form-item label="竞价类型：" prop="biddingType">
					<el-radio v-model="mediaFormData.biddingType" :label="1" :disabled="isFormDisable">客户端bidding</el-radio>
					<el-radio v-model="mediaFormData.biddingType" :label="2" :disabled="isFormDisable">服务端bidding</el-radio>
				</el-form-item>
				<el-form-item label="APP名称：" prop="name">
					<el-input clearable size="small" placeholder="请输入APP名称" v-model="mediaFormData.name"
					:disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="应用行业：" prop="industry">
					<el-select v-model="mediaFormData.industry" clearable size="small" placeholder="请选择行业"
					:disabled="isFormDisable">
						<el-option v-for="items in industryOptions" :key="items" :label="items" :value="items">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="操作系统：" prop="os">
					<el-select v-model="mediaFormData.os" clearable size="small" :disabled="isFormDisable"
					placeholder="请选择操作系统">
						<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="Bundle ID：" prop="packageN" v-if="mediaFormData.os=='IOS'">
					<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.packageN" :disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="程序主包名：" prop="packageN" v-else>
					<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.packageN" :disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="SHA1值：" prop="sha1" v-if="mediaFormData.os!=='IOS'">
					<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.sha1" :disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="应用商店：" prop="appMarket">
					<el-select v-model="mediaFormData.appMarket" clearable size="small" :disabled="isFormDisable"
					placeholder="请选择应用商店">
						<el-option v-for="item in mediaAppMarketOptions" :key="item.label" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用详情页：" prop="downLink">
					<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.downLink" :disabled="isFormDisable"></el-input>
				</el-form-item>
				<el-form-item label="微信开放平台APP ID：">
					<template slot="label">
						<div class="flex_end tipsIcon">
							<el-tooltip effect="dark" content="绑定微信App相关信息后可支持跳转微信小程序和小游戏广告; openSDK版本要求 Android端>=5.3.1，i0s端>=1.8.6" placement="top">
								<img src="../../assets/icon/iconQuestion.png" alt="" />
							</el-tooltip>
							<div>微信开放平台APP ID：</div>
						</div>
					</template>
					<el-input v-model="mediaFormData.miniAppId" size="small" placeholder="请输入" clearable :disabled="isFormDisable"></el-input>
				</el-form-item>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeMediaDialog" size="medium">取消</el-button>
				<!-- <el-button type="primary" @click="configInfoSave('ruleCompanyForm',1)" size="medium">完成</el-button> -->
				<el-button type="primary" @click="configInfoSave('ruleCompanyForm',2)" size="medium">下一步</el-button>
			</div>
		</el-form>
		<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesBaseApi" :model="mediaFormData"
			ref="ruleCompanyBaseForm" v-show="activeTab == 2">
			<div class="mianPage">
				<!-- {{adEditTitle}} -->
				<div class="titleRow">{{activeTabName}}</div>
				<div class="splitLine"></div>
				<el-form-item label="开发者类型：" prop="developerType">
					<el-select :disabled="isFormDisable" v-model="mediaFormData.developerType" clearable size="small">
						<el-option v-for="item in developerOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<div class="formDesc" v-if="mediaFormData.developerType==1">
						如您为应用的实际开发者（<span>平台注册账号是主题与软著主体一致</span>) 请提交《计算机软著著作权登记证书》或《电子版权认证证书》
					</div>
					<div class="formDesc" v-if="mediaFormData.developerType==3">
						如您与应用实际开发者为代理授权关系 （<span>定义:平台注册账号主体与软著主体不一致目存在授权关系</span>）请提交 《计算机软著著作权登记证书》或《电子版权认证证书》及《广告合作授权协议》（请下载 <a href="#" @click="downloadTemp(1)">广告合作授权协议模板</a>并上传）
					</div>
					<div class="formDesc" v-if="mediaFormData.developerType==2">
						如您与应用开发者存在主体关联关系 （定义:<span>平台注册账号主体与软著主体不一致且存在关联关系</span>） 请提交 《计算机软著著作权登记证书》或《电子版权认证证书》及《关联主体关系证明》(请下载 <a href="#" @click="downloadTemp(2)">关联证明模板</a>并上传)
					</div>
				</el-form-item>
				<el-form-item label="应用资质：">
					<template slot="label">
						<div class="flex_end tipsIcon">
							<el-tooltip effect="dark" content="应用的《计算机软著著作权登记证书》或《电子版权证书》" placement="top">
								<img src="../../assets/icon/iconQuestion.png" alt="" />
							</el-tooltip>
							<div>应用资质：</div>
						</div>
					</template>
					<el-upload v-if="!mediaFormData.id||mediaFormData.checkStatus==2||mediaFormData.checkStatus==3" ref='upload' action="#" :auto-upload="true" multiple :before-upload="handleBeforeUpload"
						:on-change="uploadFun" :file-list="fileList" :http-request="uploadSet" :on-remove="handleRemove">
						<div class="uploadBtn">
							<img class="uploadImg" src="../../assets/images/upload.png" alt="" />
							<div class="uploadTxt">点击上传</div>
						</div>
						<div slot="tip" class="el-upload__tip">支持{{ fileType.join("、") }},不超过5MB</div>
					</el-upload>
					<div v-else class="drawTableRowTwo" v-for="item in fileList" >
						<el-tooltip effect="dark" :content="item.certificationUrl" placement="top">
						  <div class="fileCont flex_start" @click="downloadFile(item)">
						  	<i style="margin-right: 10px;" class="el-icon-document"></i>
						  	<div>{{item.certificationUrl}}</div>
						  	<i style="margin-left: auto;" class="el-icon-download"></i>
						  </div>
						</el-tooltip>
					</div>
					<!-- <div class="formDesc">
						（上传文件，支持照片、pdf类型、不超过10MB）
					</div> -->
				</el-form-item>
				<el-form-item label="其他资质：">
					<el-upload v-if="!mediaFormData.id||mediaFormData.checkStatus==2||mediaFormData.checkStatus==3" ref='upload' action="#" :auto-upload="true" multiple :before-upload="handleBeforeUpload"
						:on-change="uploadFunOther" :file-list="fileListOther" :http-request="uploadSetOther" :on-remove="handleRemoveOther">
						<div class="uploadBtn">
							<img class="uploadImg" src="../../assets/images/upload.png" alt="" />
							<div class="uploadTxt">点击上传</div>
						</div>
						<div slot="tip" class="el-upload__tip">支持{{ fileType.join("、") }},不超过5MB</div>
					</el-upload>
					<div v-else class="drawTableRowTwo" v-for="item in fileListOther">
						<el-tooltip effect="dark" :content="item.certificationUrl" placement="top">
						  <div class="fileCont flex_start" @click="downloadFile(item)">
								<i style="margin-right: 10px;" class="el-icon-document"></i>
								<div>{{item.certificationUrl}}</div>
								<i style="margin-left: auto;" class="el-icon-download"></i>
							</div>
						</el-tooltip>
					</div>
				</el-form-item>
				<el-form-item label="ICP备案：">
					<el-input clearable size="small" placeholder="请输入" :disabled="isFormDisable" v-model="mediaFormData.icp"></el-input>
				</el-form-item>
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeMediaDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="backStepToOne()" size="medium" plain>上一步</el-button>
				<el-button type="primary" @click="configInfoSave('ruleCompanyBaseForm',3)" size="medium"
				:disabled="isFormDisable">提交审核</el-button>
			</div>
		</el-form>
		<el-form inline class="el-form el_dialog_form" label-width="140px" :rules="rulesQualificaApi" :model="mediaFormData"
			ref="ruleCompanyQualificaForm" v-show="activeTab == 3">
			<div class="mianPage">
				<div class="titleRow">{{activeTabName}}</div>
				<div class="splitLine"></div>
				<el-form-item label="是否网赚：">
					<template slot="label">
						<div class="flex_end tipsIcon">
							<el-tooltip effect="dark" content="网赚媒体：应用内变现，用户可通过应用内任务赚钱并提现获取收益，常见如IAA工具、游戏类媒体。" placement="top">
								<img src="../../assets/icon/iconQuestion.png" alt="" />
							</el-tooltip>
							<div>是否网赚：</div>
						</div>
					</template>
					<el-radio v-model="mediaFormData.isEarn" :label="1" :disabled="isFormDisable">是</el-radio>
					<el-radio v-model="mediaFormData.isEarn" :label="0" :disabled="isFormDisable">否</el-radio>
				</el-form-item>
				<el-form-item label="合作模式：" prop="type">
					<el-select v-model="mediaFormData.type" clearable size="small" :disabled="isFormDisable">
						<el-option label="ADN" :value="1"></el-option>
						<el-option label="聚合-黑盒" :value="2"></el-option>
						<el-option label="聚合-回传价格" :value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="素材审核方式：" prop="checkType">
					<el-select v-model="mediaFormData.checkType" clearable size="small" :disabled="isFormDisable">
						<el-option label="通投" :value="1"></el-option>
						<el-option label="先审后投" :value="2"></el-option>
						<el-option label="先投后审" :value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="服务器回调：" prop="serverCallback">
					<el-switch v-model="mediaFormData.serverCallback" :active-value="1"
					:inactive-value="0" :disabled="isFormDisable"></el-switch>
				</el-form-item>
				<el-form-item label="激励视频回调方：" v-if="mediaFormData.serverCallback == 1">
					<el-select v-model="mediaFormData.nfySwitch" clearable size="small" :disabled="isFormDisable">
						<el-option label="渠道回调" :value="1"></el-option>
						<el-option label="系统回调" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="激励视频回调地址：" v-if="mediaFormData.serverCallback == 1">
					<el-input type="textarea" :rows="2" clearable size="small" placeholder="请输入"
						v-model="mediaFormData.notifyUrl" :disabled="isFormDisable"></el-input>
				</el-form-item>
				<!-- <el-form-item label="ecpm成本控制：">
					<el-input clearable size="small" placeholder="请输入" :disabled="isFormDisable" v-model="mediaFormData.ecpmConfine">
						<i slot="suffix" style="font-style:normal;margin-right: 10px; line-height: 30px; color: #1e1e1e">分</i>
					</el-input>
				</el-form-item> -->
			</div>
			<div class="card-bottom flex_end">
				<el-button @click="closeMediaDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="backStepToTwo()" size="medium" plain>上一步</el-button>
				<el-button type="primary" @click="configInfoSave('ruleCompanyBaseForm',3)" size="medium"
				:disabled="isFormDisable">提交审核</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeTab: '1',
				activeTabName: '应用基本信息',
				adEditTitle: '新建',
				loadTypeSelectData: [], // 加载类型拉下列表
				companyOptions: [], // 公司下拉选择列表
				adTypeOptions: [], // 广告类型下拉选择
				rulesApi:{
					companyId: [{required: true,message: '请选择公司名称',trigger: 'blur'}],
					name: [{required: true,message: '请输入APP名称',trigger: 'blur'}],
					os: [{required: true,message: '请选择OS',trigger: 'blur'}],
					appMarket: [{required: true,message: '请输入应用市场',trigger: 'blur'}],
					downLink: [{required: true,message: '请输入应用详情页',trigger: 'blur'}],
					sha1: [{required: true,message: '请输入SHA1值',trigger: 'blur'}],
					packageN: [{required: true,message: '请输入包名',trigger: 'blur'}],
					industry: [{required: true,message: '请选择行业',trigger: 'blur'}],
				},
				industryOptions: [
					'社交娱乐','生活服务','网络销售','新闻资讯','金融服务','工具软件','教育','网赚激励','游戏娱乐'
				],
				developerOptions:[
					{value: 1,label:'应用开发者'},
					{value: 2,label:'与应用开发者存在主体关联关系'},
					{value: 3,label:'其他'}
				],
				// 模板选择列表
				styleCheckList: [
					{imgs:require('../../assets/images/style1.png'),imgsSelected:require('../../assets/images/styleSelected1.png'),
					name:'上文下图',checked:true},
					{imgs:require('../../assets/images/style2.png'),imgsSelected:require('../../assets/images/styleSelected2.png'),
					name:'上图下文',checked:true},
					{imgs:require('../../assets/images/style3.png'),imgsSelected:require('../../assets/images/styleSelected3.png'),
					name:'文字浮层',checked:true},
					{imgs:require('../../assets/images/style4.png'),imgsSelected:require('../../assets/images/styleSelected4.png'),
					name:'左图右文',checked:true},
					{imgs:require('../../assets/images/style5.png'),imgsSelected:require('../../assets/images/styleSelected5.png'),
					name:'左文右图',checked:true},
				],
				mediaFormData: {
					companyId: '',
					checkType: 1,
					serverCallback: 0,
					isEarn: 1,
					developerType: '',
					appProperty: 2,
					biddingType: 1,
				}, // 媒体广告位表单数据
				rulesBaseApi: {
					developerType: [{required: true,message: '请选择开发者类型',trigger: 'blur'}],
				},
				rulesQualificaApi: {},
				// companyQualificaForm: {},
				isAdEditDialog: false, //广告弹框是否编辑
				styleChecked: false,
				id: '',
				
				companyMediumOptions: [],// 所属媒介选择列表
				
				// 开票内容下拉选择
				invoiceContSelect: [
					{value:1,label:'广告发布费'},
					{value:2,label:'信息服务费'},
				], 
				// 税点下拉选择
				taxPointSelect: [
					{value:1,label:'1%'},
					{value:3,label:'3%'},
					{value:6,label:'6%'},
				],
				
				certificateType: '企业营业执照',
				fileType: ["png", "jpg", "jpeg"],
				fileSize: 3,
				
				companyDatePicker: [],
				
				
				osOptions: this.$api.osOptions, // OS下拉选择列表
				mediaAppMarketOptions: [],// 应用市场下拉列表
				
				fileList: [],
				fileType: ["pdf", "png", "jpg", "jpeg", "webp"],
				fileListOther: [],
			}
		},
		computed: {
		  isFormDisable() {
				// ||this.mediaFormData.status == 0
		    return this.mediaFormData.checkStatus == 1;
		  }
		},
		activated(){
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.getFormData();
				this.isAdEditDialog = true
				this.adEditTitle = '编辑'
			}else{
				this.activeTab = '1'
				this.mediaFormData = {
					companyId: '',
					checkType: 1,
					serverCallback: 0,
					isEarn: 1,
					developerType: '',
					appProperty: 2,
					biddingType: 1
				}
			}
			this.getCompanyOption();
		},
		mounted() {
			this.getADTypeOption();
			// this.getOSOption();
			this.getMediaAppMarketOption();
			// this.getCompanyOption();
		},
		methods: {
			tabChange(tab, event) {
				this.activeTabName = tab.$options.propsData.label
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
				if(!this.id){
					if (this.$route.query.companyName) {
						this.$nextTick(() => {
							this.companyOptions.forEach((item)=>{
								if(item.label === this.$route.query.companyName){
									this.mediaFormData.companyId = item.value
								}
							})
						})
					}
				}
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			// 获取应用市场下拉列表
			async getMediaAppMarketOption() {
				let res = await this.$http.get(this.$api.common.mediaAppMarketOption);
				this.mediaAppMarketOptions = res.data
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
			},
			// 获取详情信息
			async getFormData() {
				let data = {
					pageNum: 1,
					pageSize: 10,
					id: this.id
				}
				let res = await this.$http.post(this.$api.mediaManage.APPList, data);
				if(res.data.list&&res.data.list.length>0){
					this.mediaFormData = res.data.list[0];
					this.fileList = []
					this.fileListOther = []
					if(this.mediaFormData.certificationUrl&&this.mediaFormData.certificationUrl.length>0){
						let obj = {}
						for(let i=0;i<this.mediaFormData.certificationUrl.length;i++){
							obj['certificationType'] = 1
							obj['certificationUrl'] = this.mediaFormData.certificationUrl[i]
							obj['name'] = this.mediaFormData.certificationUrl[i]
							this.fileList.push(obj)
							obj = {}
						}
					}
					// console.log(this.fileList)
					if(this.mediaFormData.otherCertificationUrl&&this.mediaFormData.otherCertificationUrl.length>0){
						let obj = {}
						for(let i=0;i<this.mediaFormData.otherCertificationUrl.length;i++){
							obj['certificationType'] = 2
							obj['certificationUrl'] = this.mediaFormData.otherCertificationUrl[i]
							obj['name'] = this.mediaFormData.certificationUrl[i]
							this.fileListOther.push(obj)
							obj = {}
						}
					}
				}
			},
			backStepToOne(){
				this.activeTab = '1'
			},
			backStepToTwo(){
				this.activeTab = '2'
			},
			// 表格弹窗关闭
			closeMediaDialog() {
				// this.dialogVisible = false
				if(this.adEditTitle == '新建'){
					let msg = '退出后已编辑的内容将不会保留，请确认您是否 退出。'
					let dialogtitle = '确定退出' + this.adEditTitle + '应用吗？';
					this.$confirm(msg, dialogtitle, {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.go(-1);
					}).catch();
				}else{
					this.$router.go(-1);
				}
			},
			// 公司配置信息保存
			configInfoSave(formName,type){
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if(type == 1){
							this.confirmCompanyInfo(this.mediaFormData);
						}else if(type == 2){
							this.activeTab = '2'
						}else if(type == 3){
							if(this.mediaFormData.checkStatus == 2 && this.mediaFormData.status == 1 ){
								this.$confirm('修改应用信息会再次触发应用审核。是否提交审核', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									this.confirmCompanyInfo(this.mediaFormData);
								}).catch();
							}else{
								this.confirmCompanyInfo(this.mediaFormData);
							}
						}
					}
				})
			},
			async confirmCompanyInfo(formData){
				let data = formData;
				if(this.fileList.length<=0){
					this.$message.warning('请上传应用资质');
					return
				}
				data['detail'] = this.fileList.concat(this.fileListOther)
				if (data.id) {
					let res = await this.$http.post(this.$api.mediaManage.APPEdit, data);
					if (res.code == 1) {
						this.$message.success('修改成功');
						this.$router.go(-1);
					}
				} else {
					let res = await this.$http.post(this.$api.mediaManage.APPAdd, data);
					if (res.code == 1) {
						this.$message.success('新增成功');
						this.$router.go(-1);
					}
				}
			},
			checkChange(e, index) {
				let obj = this.styleCheckList[index]
				obj.checked = e
				this.$set(this.styleCheckList, index, obj)
			},
			
			uploadSetOther(){},
			handleBeforeUpload(file) {
				// 文件类型校验
				let fileExtension = "";
				if (file.name.lastIndexOf(".") > -1) {
					fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
				}
				// 校检文件大小
				if (this.fileSize) {
				  const isLt = file.size / 1024 / 1024 < this.fileSize;
				  if (!isLt) {
				    this.$message.warning(`上传文件大小不能超过 ${this.fileSize} MB!`);
				    return false;
				  }
				}
				const isTypeOk = this.fileType.some((type) => {
					// if (file.type.indexOf(type) > -1) return true;
					if (fileExtension && fileExtension.indexOf(type) > -1) return true;
					return false;
				});
				if (!isTypeOk) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
					return false;
				}
				return true
			},
			deletePoster() {
				this.mediaFormData.businessPhotoUrl = ''
			},
			//上传图片**********营业执照
			async onChangeImg(file, fileList, type) {
				const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				const isTypeOk = this.fileType.includes(fileExtension);
				if (!isTypeOk) {
					return false; // 阻止文件上传并移除
				}
				if(file.size / 1024 / 1024 > this.fileSize){
					return false
				}
				let formdata = new FormData;
				formdata.append('file', file.raw)
				let res = await this.$http.post(this.$api.common.uploadFile, formdata);
				if (res.code == 1) {
					if(type==1){
						this.mediaFormData.businessPhotoUrl = res.data.url
						this.$forceUpdate();
					}
				}
			},
			
			handleBeforeUpload(file) {
				// 文件类型校验
				let fileExtension = "";
				if (file.name.lastIndexOf(".") > -1) {
					fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
				}
				const isTypeOk = this.fileType.some((type) => {
					// if (file.type.indexOf(type) > -1) return true;
					if (fileExtension && fileExtension.indexOf(type) > -1) return true;
					return false;
				});
				if (!isTypeOk) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
					return false;
				}
				return true
			},
			// 上传文件
			async uploadFun(file) {
				console.log(file)
				if(this.fileList.length>=5){
					this.$message.warning(`文件数量最多不超过5个!`);
					return
				}
				const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				const isTypeOk = this.fileType.includes(fileExtension);
				if (!isTypeOk) {
					return false; // 阻止文件上传并移除
				}
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				let res = await this.$http.post(this.$api.common.uploadFile, formdata);
				if (res.code == 1) {
					let obj = {
						certificationType: 1,
						name: res.data.url,
						certificationUrl: res.data.url
					}
					this.fileList.push(obj)
				}
			},
			//移除文件
			handleRemove(file) {
				let index = -1
				for (let i = 0; i < this.fileList.length; i++) {
					if (file.name == this.fileList[i].certificationUrl) {
						index = i
					}
				}
				if (index >= 0) this.fileList.splice(index, 1)
				console.log(this.fileList)
			},
			uploadSet() {},
			async uploadFunOther(file){
				if(this.fileListOther.length>=5){
					this.$message.warning(`文件数量最多不超过5个!`);
					return
				}
				const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				const isTypeOk = this.fileType.includes(fileExtension);
				if (!isTypeOk) {
					return false; // 阻止文件上传并移除
				}
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				let res = await this.$http.post(this.$api.common.uploadFile, formdata);
				if (res.code == 1) {
					let obj = {
						certificationType: 2,
						name: res.data.url,
						certificationUrl: res.data.url
					}
					this.fileListOther.push(obj)
				}
			},
			handleRemoveOther(file){
				let index = -1
				for (let i = 0; i < this.fileListOther.length; i++) {
					if (file.name == this.fileListOther[i].certificationUrl) {
						index = i
					}
				}
				if (index >= 0) this.fileListOther.splice(index, 1)
			},
			// 下载文件
			downloadFile(item) {
				let a = document.createElement('a')
				a.href = item.certificationUrl
				a.click();
			},
			async downloadTemp(type){
				let data = {
					type: type
				}
				let res = await this.$http.get(this.$api.mediaManage.download, data);
				if (res.code == 1) {
					let a = document.createElement('a')
					a.href = res.data
					a.click();
				}
			},
			uploadSetOther(){},
		},
	}
</script>

<style scoped>
	.headTabs {
		background: #FFFFFF;
		padding: 0 20px;
		margin: 10px;
		font-size: 16px;
	}
	/deep/ .el-tabs__header{
		margin-bottom: 0;
	}
	/* 使用 /deep/ 选择器覆盖 Element UI 的默认样式 */
	/deep/ .el-tabs__nav-wrap::after {
	  height: 0; /* 移除底部的边框线 */
	}
	/deep/ .el-tabs__item{
		height: 48px;
		line-height: 48px;
		color: #999999;
	}
	/deep/ .el-tabs__item.is-active{
		color: #007FFF;
	}
	.mianPage {
		margin: 10px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 24px;
		padding-bottom: 5px;
	}
	.titleRow{
		font-weight: 500;
		font-size: 17px;
		color: #333333;
		line-height: 22px;
		padding-left: 8px;
		border-left: 2px solid #4F7AFD;
	}
	.splitLine{
		width: 100%;
		height: 1px;
		background: #EEEEEE;
		margin-top: 12px;
		margin-bottom: 18px;
	}
	.el-form {
		/* margin-top: 24px; */
		/* flex-wrap: wrap; */
	}
	
	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	/deep/ .el-select{
		width: 50%;
	}
	/deep/ .el-select>.el-input{
		width: 80%;
	}
	/deep/ .el-input{
		width: 40%;
	}
	.styleList{
		flex-wrap: wrap;
		width: 60%;
	}
	.styleCheckBox{
		border: 1px solid #F9F8F7;
		background: #F9F8F7;
		width: 242px;
		height: 90px;
		box-sizing: border-box;
		border-radius: 8px;
		padding: 0 13px;
		align-items: center;
		position: relative;
		cursor: pointer;
		margin-right: 12px;
		color: #333333;
		margin-top: 12px;
	}
	.styleCheckBox img{
		width: 64px;
		height: 64px;
	}
	.styleTxt{
		margin-left: 12px;
		font-weight: 600;
		font-size: 14px;
	}
	.checkContainer{
		position: absolute;
		right: -5px;
		top: 0px;
		z-index: 14;
		width: 242px;
		height: 92px;
	}
	.checkeds {
		position: absolute;
		right: 5px;
		top: 0px;
		z-index: 14;
	}
	.styleBoxActive{
		border: 1px solid #4F7AFD;
		background: #FFFFFF;
		color: #4F7AFD;
	}
	/* .styleTxtActive{
		color: #4F7AFD;
	} */
	.card-bottom {
		height: 64px;
		background: #FFFFFF;
		align-items: center;
		padding-right: 24px;
		margin: 10px;
	}
	/deep/.el-collapse-item__header{
		margin-left: 22px;
	}
	
	.upload-demo{
		margin-top: 8px;
	}
	.addImg{
		width: 120px;
		height: 120px;
		border: 1px dashed #eee;
		margin: 0px 0;
		align-items: center;
	}
	.addImg img{
		width: 20px;
		height: 20px;
	}
	/* .upload_img{
		width: 120px;
		height: 120px;
		margin: 0px 0;
		position: relative;
	} */
	.closeImgIcon {
		position: absolute;
		right: -10px;
		top: -14px;
		height: 20px;
		width: 20px;
		cursor: pointer;
	}
	
	.closeImgIcon i {
		font-size: 20px;
	}
	
	.tipsIcon{
		align-items: center;
		/* padding-right: 12px; */
	}
	.tipsIcon img{
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}
	
	.auditStatus {
		align-items: center;
		font-weight: 500;
		font-size: 14px;
	}
	
	.statusLabel {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 4px;
		background: #FA9600;
	}
	.rejectTxt{
		font-size: 12px;
		color: #333333;
		height: 24px;
		line-height: 24px;
		background: #FDF3F0;
		padding: 0 6px;
		border: 1px solid #FC474C;
		border-radius: 4px;
		box-sizing: border-box;
		margin-left: 5px;
	}
	.el_dialog_forms /deep/.el-form-item {
		width: 100%;
	}
	.el_dialog_forms /deep/.el-form-item__content {
		width: calc(100% - 200px);
	}
	
	.formDesc {
		font-weight: 500;
		font-size: 12px;
		color: #999999;
		line-height: 18px;
		margin-top: 4px;
	}
	
	.formDesc span {
		color: #FC474C;
	}
	
	.uploadBtn {
		width: 108px;
		height: 32px;
		background: #FAFAFA;
		border-radius: 2px;
		border: 1px solid #E0E0E0;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		margin-top: 4px;
	}
	
	.uploadImg {
		width: 16px;
		height: 16px;
		margin-right: 5px;
	}
	
	.uploadTxt {
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	
	.el-upload__tip {
		font-weight: 500;
		font-size: 12px;
		color: #AAAAAA;
	}
	
	.drawTableRow,
	.drawTableRowTwo {
		background: #F7F8F9;
		height: 47px;
		border-bottom: 1px solid #EAEFF5;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 16px;
	}
	
	.drawTableRowTwo {
		background: none;
		border: none;
		padding: 0;
	}
	
	.rowContent {
		font-weight: 600;
		font-size: 14px;
		color: #666666;
		margin-right: 40px;
	}
	
	.fileCont {
		width: 100%;
		height: 32px;
		font-family: PingFang SC, PingFang SC;
		/* background: #F7F7F7; */
		font-weight: 500;
		font-size: 12px;
		color: #333333;
		line-height: 32px;
		padding: 0 10px;
		white-space: nowrap; 
		overflow: hidden; 
		text-overflow: ellipsis; 
		cursor: pointer;
		width: 40%;
		border:  1px solid #D5D5D4;
		border-radius: 4px;
		align-items: center;
		box-sizing: border-box;
	}
	.fileCont i{
		font-size: 16px;
	}
	/deep/ .el-upload-list__item{
		border: 1px solid #D5D5D4;
		width: 50%;
		line-height: 32px;
		height: 32px;
		margin-top: 14px;
	}
</style>